import Questionnaire from "../../../views/Questionnaires/index"
import list from "../../../views/Questionnaires/list"

import maintenance from "../../../views/Questionnaires/components/maintenance/index.vue"
import section_maintenance from "../../../views/Questionnaires/components/section/section.vue"
import question_maintenance from "../../../views/Questionnaires/components/question/question.vue"


export default {
    path: '/Questionnaire',
    component: Questionnaire,
    children: [{
        path: '/',
        component: list,
    }, {
        path: '/Questionnaire/Maintenance/:questionnaireId',
        component: maintenance,
    }, {
        path: '/Questionnaire/Maintenance/:questionnaireId/Section/:sectionId',
        component: section_maintenance,
    }, {
        path: '/Questionnaire/Maintenance/:questionnaireId/Section/:sectionId/Question/:questionId',
        component: question_maintenance
    }]
}